import React, {useState} from 'react';
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { FormField } from "../../sharedComponents/formField";
import { getProgressMemberWeightHistoryList, postAddWeight } from "../../store/actions";
import { Modal, Collapse, Button } from "react-bootstrap";
import { required } from "../../constants/formValidators";
import { NotificationManager } from "react-notifications";

const AddWeightModal = ({ handleSubmit, show, onHide, postAddWeight, onCreate }) => {
    const [error, setError] = useState(null);
    const validateForm = (values) => {
        const successHandler = (event) => {
            if (event.status >= 200 && event.status < 300) {
                NotificationManager.success("Weight Entry Added!", "", 5000);
                onHide(false);
                onCreate();
                setError(null);
                this.props.resetForm("AddWeightForm");
            } else {
                NotificationManager.error("Please try again!", "", 5000);
            }
        };
        const errorHandler = (event) => {
            if (event && event.error_code === "VALIDATION_ERROR") {
				setError(event.errors.error);
			}
        };
        postAddWeight(values, successHandler, errorHandler);
    };
    const [open, setOpen] = useState(false);

	return (
		<Modal className="add-weight-modal" show={show} onHide={onHide}>
            <form className="" onSubmit={handleSubmit(validateForm)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Weight</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && error.general && <div className="error text-danger text-center mt-3">{error.general}</div>}
                    <Field label="Weight" name="weight" type="number" component={FormField} validate={[required]} />
                    {error && error.weight && <div className="error text-danger text-center mt-3">{error.weight}</div>}
                    <Collapse in={open}>
                        <div id="collapse-text">
                            <Field label="Impedance" name="impedance" type="number" component={FormField} />
                            <Field label="Fat" name="fat" type="number" component={FormField} />
                            {error && error.fat && <div className="error text-danger text-center mt-3">{error.fat}</div>}
                            <Field label="Fat Mass" name="fat_mass" type="number" component={FormField} />
                            <Field label="Fat-Free Mass" name="ffm" type="number" component={FormField} />
                            <Field label="Total Body Water" name="tbw" type="number" component={FormField} />
                            <Field label="BP Systolic" name="bp_systolic" type="number" component={FormField} />
                            <Field label="BP Diastolic" name="bp_diastolic" type="number" component={FormField} />
                            <Field label="Pulse" name="pulse" type="number" component={FormField} />
                            <Field label="Waist Circumference" name="waist_circumference" type="number" component={FormField} />
                        </div>
                    </Collapse>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => setOpen(!open)}
                        controls="collapse-text"
                        expanded={open}
                        className="btn btn-primary-dark btn-ghost"
                    >
                        {open?"Hide Body Composition":"Show Body Composition"}
                    </Button>
                    <button type="submit" className="btn btn-primary text-uppercase">
                        Add Weight
                    </button>
                </Modal.Footer>
            </form>
		</Modal>
	);
};

const mapDispatchToProps = {getProgressMemberWeightHistoryList, postAddWeight};

export default connect(
    null,
    mapDispatchToProps
   )(
    reduxForm({
    form: "AddWeightForm"
    })(AddWeightModal)
   );
